import { useParams } from 'react-router-dom'
import { BulkJobView } from '@/components/domains/bulk-job-view'

export function BulkJobDetailPage() {
  const { jobId } = useParams<{ jobId: string }>()

  if (!jobId) return null

  return <BulkJobView jobId={jobId} backHref="/dashboard/domains/verify" />
}
